export class ViewType {
    type: string;
}